import { render, staticRenderFns } from "./BaskoBoxPaymentMethod.vue?vue&type=template&id=5048e6b2&"
import script from "./BaskoBoxPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./BaskoBoxPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./BaskoBoxPaymentMethod.vue?vue&type=style&index=0&id=5048e6b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports